/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useState, useEffect, useRef } from 'react';

import FilterMenu from './FilterMenu';
import { FilterConfig, SearchInputFilterConfig } from './FilterTypes';

import './styles.scss';

interface SearchAndFiltersProps {
  config: FilterConfig;
  onChange: () => void; // Callback for value changes
}

const SearchAndFilters: React.FC<SearchAndFiltersProps> = ({
  config,
  onChange,
}) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);
  const panelRef = useRef<HTMLDivElement>(null);
  const searchInputRef = useRef<HTMLDivElement>(null);

  const handleClickOutside = (event: MouseEvent) => {
    if (
      panelRef.current &&
      !panelRef.current.contains(event.target as Node) &&
      searchInputRef.current &&
      !searchInputRef.current.contains(event.target as Node)
    ) {
      setIsPanelOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="search-and-filter-bar-container p-0" ref={panelRef}>
      {/* Search Bar */}
      <div ref={searchInputRef} onFocus={() => setIsPanelOpen(true)}>
        {config.filters
          .filter((filter) => filter.id === 'search')
          .map((filter) => {
            const searchFilter = filter as SearchInputFilterConfig;
            searchFilter.onFilterClick = () => {
              setIsPanelOpen(!isPanelOpen);
            };

            return searchFilter.render(onChange);
          })}
      </div>

      {/* Filter Panel */}
      {isPanelOpen && (
        <div className="filter-menu border rounded shadow-sm p-0">
          <FilterMenu
            filterConfigs={config}
            onChange={() => onChange()}
            onDone={() => setIsPanelOpen(false)}
          />
        </div>
      )}
    </div>
  );
};

export default SearchAndFilters;
